<template>
    <div>
      <apexchart type="donut" :options="options" :series="series"></apexchart>
    </div>
  </template>

<script>
import apexchart from 'vue-apexcharts'

export default {
  components: {
    apexchart
  },
  data: function() {
    return {
      options: {
        labels: [],
        responsive: [{
          options: {
            legend: {
              position: 'right'
            }
          }
        }],
        dataLabels: {
          enabled: true,
          formatter: function (val, opts) {
            return val.toFixed(2) + '%'
          },
        },
        stroke: {
          width: 1
        },
        series: [],
        tooltip: {
          show: false,
          custom: function({series, seriesIndex, w}) {
              return '<div class="arrow_box">' +
                '<span>' + series[seriesIndex] + '%' + '</span>' +
                '</div>'
            }
        },
        legend: {}
      },
      series: [0]
    }
  },
  methods: {
    loadData() {
        var context = this; 
        if (this.values != undefined)
        {
            var listData = []
            var listLabels = []
            var itens = 0
            this.values.forEach(item => {
              if (item.itemName == null) {
                listLabels.push('Não Informado');
                listData.push(item.qtAnimais);
              }
              else if (item.itemName != "Total") {
                listLabels.push(item.itemName);
                listData.push(item.qtAnimais);
              }
            })
            context.series = listData,
            context.options = {
                labels: listLabels,
                responsive: [{
                    options: {
                        legend: {
                                position: 'right'
                            }
                        }
                }],
                dataLabels: {
                    enabled: true,
                    formatter: function (val, opts) {
                        return val.toFixed(2) + '%'
                    },
                },
                stroke: {
                    width: 1,
                },
                tooltip: {
                    show: false,
                    custom: function({series, seriesIndex, w}) {
                        return '<div class="arrow_box" style="padding: 5%;">' +
                            '<span><b>' + context.values[seriesIndex].itemName + ": " + '</b></span></br>' +
                            '<span>' + 'Qtd: ' + context.values[seriesIndex].qtAnimais + '</span></br>' +
                            '<span>' + context.values[seriesIndex].qtPercent + ' %' + '</span>' +                
                            '</div>'
                        },
                    fillSeriesColor: true,
                },
                legend: {
                    position: 'bottom',
                    horizontalAlign: 'left',
                    fontSize: '17px',
                    labels: {
                        useSeriesColors: false
                    },
                },
                plotOptions: {
                    pie: {
                        donut: {
                            size: '65%'
                        }
                    }
                },
                chart: {
                  height: 400,
                }
            }
        }
    }
  },
  mounted() {
    this.loadData();
  },
  props: {
    values: Array,
    isNotMobile: {
      type: Boolean,
      default: false
    }
  }
}

</script>


